import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface prepareSubmitFormProps {
  submitForm: Function
  data: any
  navigate: Function
  id: string | undefined
  name: string
  setError?: Function
  optionalParameters?: any
}

const prepareSubmitForm = async (props: prepareSubmitFormProps) => {
  props
    .submitForm({
      data: props.data,
      id: props.id,
      setError: props?.setError,
      ...props.optionalParameters,
    })
    .then((response: any) => {
      if (response?.status === 200 || response?.status === 201) {
        Store.dispatch(setMessage(props.name + ' successfully saved.', 'success', 'instant'))
        props.optionalParameters?.setDependency(++props.optionalParameters.dependency)
        props.optionalParameters?.reset()
      }
    })

  return true
}

export default prepareSubmitForm
